import { ArrowUpLeft } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

const BASE = "https://connected-center-basra.aglowspark17.chatgpt.site";

const FEATURED = [
  {
    id: "work-tahoe",
    num: "01",
    car: "CHEVROLET TAHOE",
    image: `${BASE}/brochures/work-assets/288a624043cf65b5fe62bf2a.jpg`,
  },
  {
    id: "work-mercedes",
    num: "02",
    car: "MERCEDES-BENZ",
    image: `${BASE}/brochures/work-assets/207d9c3535d99a582dd8e596.jpg`,
  },
  {
    id: "work-bmw",
    num: "03",
    car: "BMW",
    image: `${BASE}/brochures/work-assets/da4876cf51e70aa2c65edc7b.jpg`,
  },
];

const GALLERY = [
  { src: `${BASE}/latest/02.webp`, alt: "Mercedes G Class" },
  { src: `${BASE}/latest/04.webp`, alt: "Protection and elegance" },
  { src: `${BASE}/latest/06.webp`, alt: "Color selection" },
  { src: `${BASE}/latest/08.webp`, alt: "Connected colors and details" },
  { src: `${BASE}/latest/01.webp`, alt: "Connected Center identity" },
  { src: `${BASE}/latest/03.webp`, alt: "Paint protection" },
];

export default function Works() {
  const { t } = useLang();
  return (
    <section id="works" data-testid="works-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="mb-3 flex items-center gap-3 text-xs font-bold tracking-[0.25em] text-[#E3AF4F]">
            <span className="h-px w-10 bg-[#E3AF4F]" />
            {t.works.eyebrow}
          </p>
          <h2 className="font-heading text-2xl font-bold leading-snug text-[#F5F2EB] sm:text-3xl lg:text-4xl">
            {t.works.heading}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {FEATURED.map((w, i) => {
            const text = t.works.featured[i];
            return (
              <Reveal key={w.id} delay={i * 0.1}>
                <article
                  data-testid={`work-card-${w.id}`}
                  className="group relative overflow-hidden rounded-3xl border border-[#F5F2EB]/10 transition-all duration-500 hover:-translate-y-1 hover:border-[#E3AF4F]/50"
                >
                  <img
                    src={w.image}
                    alt={text.alt}
                    loading="lazy"
                    className="h-80 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#000000]/95 via-[#000000]/20 to-transparent" />
                  <span className="absolute end-5 top-5 font-heading text-sm font-bold tracking-widest text-[#F5F2EB]/60">
                    {w.num}
                  </span>
                  <span className="absolute start-5 top-5 flex h-9 w-9 items-center justify-center rounded-full border border-[#F5F2EB]/20 bg-[#000000]/50 backdrop-blur transition-colors duration-300 group-hover:border-[#E3AF4F] group-hover:bg-[#E3AF4F] group-hover:text-[#000000]">
                    <ArrowUpLeft size={16} className="rtl:-scale-x-100" />
                  </span>
                  <div className="absolute inset-x-0 bottom-0 p-6">
                    <h3 className="font-heading text-lg font-bold text-white">{text.title}</h3>
                    <p className="mt-1 text-[11px] font-bold tracking-[0.25em] text-[#E3AF4F]">
                      {w.car}
                    </p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1} className="mt-16">
          <p className="mb-6 flex items-center gap-3 text-xs font-bold tracking-[0.25em] text-[#A8A29E]">
            <span className="h-px w-10 bg-[#F5F2EB]/20" />
            {t.works.journal}
          </p>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {GALLERY.map((g, i) => (
              <div
                key={g.src}
                data-testid={`gallery-item-${i + 1}`}
                className="group overflow-hidden rounded-2xl border border-[#F5F2EB]/10"
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  loading="lazy"
                  className="h-40 w-full object-cover transition-transform duration-700 group-hover:scale-110 lg:h-44"
                />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
